const industries = [
  {
    icon: 'ri-store-2-line',
    title: 'Retail',
    description: 'Comprehensive security solutions for retail environments',
  },
  {
    icon: 'ri-hotel-line',
    title: 'Hospitality',
    description: 'Professional protection for hotels and resorts',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Commercial',
    description: 'Office buildings and commercial property security',
  },
  {
    icon: 'ri-government-line',
    title: 'Government',
    description: 'Specialized security for government facilities',
  },
  {
    icon: 'ri-ship-line',
    title: 'Maritime',
    description: 'Port and cruise ship security operations',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Residential',
    description: 'Gated communities and residential security',
  },
];

const IndustriesServed = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary-600 font-semibold text-sm uppercase tracking-wider">
            Multifaceted Security Services
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-dark-900 mt-4 mb-6 font-display">
            Industries We Serve
          </h2>
          <p className="text-dark-600 text-lg max-w-3xl mx-auto">
            American Guard Services delivers tailored security solutions across a wide range of industries, providing trusted protection wherever it's needed most.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="bg-dark-50 rounded-lg p-8 hover:bg-primary-50 transition-all hover:transform hover:scale-105 cursor-pointer group border border-dark-200"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-white rounded-lg mb-6 group-hover:bg-primary-500 transition-colors shadow-sm">
                <i className={`${industry.icon} text-3xl text-primary-600 group-hover:text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-dark-900 mb-3">{industry.title}</h3>
              <p className="text-dark-600 text-sm">{industry.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesServed;